<template>
    <drag-and-drop-wrapper>
        <template v-slot:="{jsPlumbInstance}">
            <div class="track" @click.self="moveToXViaTrack($event.x)">
                <drag-and-drop-draggable 
                    :js-plumb-instance="jsPlumbInstance" 
                    :containment="true"
                    @drag="draggedToXViaNob($event.pos[0])"
                    @stop="dragStoppedToXViaNob($event.pos[0])"
                >
                    <div 
                        class="nob" 
                        :class="{ dragging: isDragging }" 
                        :style="`left: ${nobTrackPosition}px; width: ${nobWidth}px`"
                        
                        @mousedown="isDragging = true"
                        @mouseup="isDragging = false"
                    />
                </drag-and-drop-draggable>
            </div>
        </template>
    </drag-and-drop-wrapper>
</template>

<script>
import constants from "./constants";

import DragAndDropWrapper from "@core/Components/DragAndDrop/DragAndDropWrapper";
import DragAndDropDraggable from "@core/Components/DragAndDrop/DragAndDropDraggable";

export default {
    name: "horizontal-scroll",
    components: {
        DragAndDropWrapper,
        DragAndDropDraggable
    },
    mounted() {
        this.updateWidthData();

        //ResizeObserver is a fairly new API; wrap it in a conditional for safety
        //Without our observer, the client might experience a small unusable part of the track near the far right 
        //This occurs upon using the browser zoom functionality
        if(window.ResizeObserver){
            const observer = new window.ResizeObserver(() => {
                this.updateWidthData();
            });

            observer.observe(this.$el);
            this.resizeObserver = observer;
        }
    },
    methods: {
        updateWidthData(){
            const { width: trackWidth, x: trackX } = this.$el.getBoundingClientRect();

            //Set trackWidth/trackX only when updated for performance reasons
            //we don't expect resizing to happen often
            this.trackWidth = trackWidth;
            this.trackX = trackX;
        },
        dragStoppedToXViaNob(x){
            //We can't accurately capture mouseout events
            //thus we also need to set our dragging state to false upon drag stop
            this.isDragging = false;
            
            this.draggedToXViaNob(x);
        },
        draggedToXViaNob(x){
            this.moveNobToX(x);
        },
        moveToXViaTrack(x){
            //x is the position of the track part in the page
            //calculate the actual selected trackX by subtracting the track start x from our given x  
            const trackX = x - this.trackX;
            this.moveNobToX(trackX);
        },
        moveNobToX(x) {
            const newXAreaPercentage = this.toValidX(x) / this.trackWidth;
            const newX = this.minLeft + (this.coveredArea * newXAreaPercentage);
            
            this.$emit('update:position', newX);
        },
        toValidX(x){
            return Math.max(
                0,
                Math.min(x, this.trackWidth - this.nobWidth)
            );
        }
    },
    computed: {
        coveredArea(){
            //max: 1799
            //min: -748
            //area: 2547
            return this.maxLeft + -this.minLeft;
        },
        nobTrackPosition(){
            //position: 0
            //min: -748
            //max: 1799
            //Difference to min: 748
            //Percentage of area: ~29%
            let positionPercentage = ((this.position - this.minLeft) / this.coveredArea);
            positionPercentage = Math.max(0, Math.min(1, positionPercentage));
            
            //Prevent nob from going out of bounds
            return this.toValidX(positionPercentage * this.trackWidth);
        },
        nobWidth(){
            return Math.max(
                this.trackWidth / this.coveredArea * this.trackWidth,
                constants.MINIMUM_NOB_SIZE
            );
        }
    },
    props: {
        minLeft: 0,
        maxLeft: 0,

        position: 0
    },
    data: () => ({
        resizeObserver: null,

        trackWidth: 0,
        trackX: 0,
        isDragging: false
    })
}
</script>

<style scoped lang="scss">
@import "shared";

.track {
    height: $track-width;
    width: $track-size;
}

.nob {
    height: 100%;
}
</style>